import { render, staticRenderFns } from "./PromoPremium.vue?vue&type=template&id=58b05b67&"
import script from "./PromoPremium.vue?vue&type=script&lang=js&"
export * from "./PromoPremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports